const State = {
  productAndStockList: [],
  productList: [],
  makerList: []
}

export default State
